import React from "react";

const ProjectsTableBody = ({
  currentProjects = [],
  projectDetail,
  formatCurrency,
}) => {
  if (currentProjects.length === 0) {
    return (
      <tbody>
        <tr>
          <td colSpan="7" className="text-center">
            No projects available
          </td>
        </tr>
      </tbody>
    );
  }

  return (
    <tbody>
      {currentProjects.map((project) => {
        const pmFirst = project?.project_manager_first_name || "";
        const pmLast = project?.project_manager_last_name || "";

        return (
          <tr
            key={project?.pid}
            onClick={() => projectDetail(project?.pid)}
            style={{ cursor: "pointer" }}
          >
            <td>{project?.project_code}</td>
            <td>{project?.project_name}</td>
            <td>{project?.client}</td>
            <td>
              {pmFirst} {pmLast}
            </td>
            <td>{formatCurrency(project?.budget)}</td>
            <td>{project?.start_date}</td>
            <td>{project?.end_date}</td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default ProjectsTableBody;
